import React from 'react';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';  // Import Search Icon
import Stopcon from "./Stopcon";

const SearchBar = React.memo(({ searchQuery, setSearchQuery, isCircleGreen, handleCircleToggle }) => (
    <div className="search-input-container">
        <div className="search-button-1">
            <Button variant="contained" color="default">
                <SearchIcon />
            </Button>
        </div>
        <input
            type="text"
            placeholder="Search trading token"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input-box"
        />
        <Stopcon
            fontSize="large"
            isGreen={isCircleGreen}
            onClick={handleCircleToggle}
        />
    </div>
));

export default SearchBar;
